(ns frontend.actions.kyc-process
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]
   [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/account
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->invite!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/invite!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->re-invite!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/re-invite!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->prefilled
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/prefilled! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->complete!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/complete-form! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->uploaded-signed-document
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/uploaded-signed-document data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->re-edit-form!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/re-edit-form! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->submit-for-review!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/submit-for-review! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->approve!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/approve! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->modify-after-approval!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/modify-after-approval! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->reject!
  [data on-success! on-error!]
  (-> (conn/sendp! :kyc-process/reject! data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->enrich-data!
  [action-type data on-success! on-error!]
  (-> (conn/sendp! action-type data)
      (p/then on-success!)
      (p/catch on-error!)))

